import React from 'react';
import classnames from 'classnames';

/**
 * A table order's table, in the Orders app's grey box (26 px bold), so staff read it from a step
 * away. Used under the guest's name in the order drawer (PROD-724).
 */
export default function OrderTableBox({ children, className = '' }) {
  return (
    <p
      className={classnames(
        'm-0 mt-2 inline-block max-w-full rounded bg-gray-100 px-sm py-2xs text-[26px] font-bold leading-tight text-gray-900 break-words',
        className,
      )}
      data-testid="order-table-box"
    >
      {children}
    </p>
  );
}
